import { Injectable } from "@angular/core";
import { Appareil } from "src/app/domain/Qualif/appareil";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { AppareilEntity } from "../appareil.entity";
import { PrelevementQualifSalleEntity } from "../prelevement-qualif-salle.entity";
import { PrelevementAirEntity } from "../prelevement-air.entity";
import { ETypeAppareil } from "src/app/domain/Qualif/enums/type-appareil";

@Injectable({
    providedIn: 'root',
})
export class AppareilRepository {
    constructor() { }

    async getAppareilEntityByCode(code: string) {
        return await db.appareils.where('Code').equals(code).first(async me => {
            return me;
        });
    }

    async getAppareilById(id: number) {
        return await db.appareils.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, AppareilEntity, Appareil)

            return z;
        });
    }

    async getAppareilEntityById(id: number) {
        return await db.appareils.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }


    /** DEPRECATED */
    async attachAppareil(ps: Appareil, prelevementQualifSalleEntity: PrelevementQualifSalleEntity) {
        let aeId: number;
        const ae = mapper.map(ps, Appareil, AppareilEntity);

        // const qse = await this.qualifSalleRepository.getQualifSalleEntityById(qualifSalleId);
        ae.Id = await db.appareils.add(ae);
        // prelevementQualifSalleEntity!.AppareilIds = prelevementQualifSalleEntity?.AppareilIds ? [...prelevementQualifSalleEntity.AppareilIds, ae.Id] : [ae.Id]
        // await db.prelevementQualifSalles.update(prelevementQualifSalleEntity.Id!, {
        //     AppareilIds: prelevementQualifSalleEntity?.AppareilIds
        // });

        return ae.Id;
    }

    /** DEPRECATED */
    async attachAppareilToAir(ps: Appareil, paId: number) {
        let aeId: number;
        const ae = mapper.map(ps, Appareil, AppareilEntity);

        // const qse = await this.qualifSalleRepository.getQualifSalleEntityById(qualifSalleId);
        ae.Type = ETypeAppareil.Biocollecteur;
        ae.Id = await db.appareils.add(ae);
        await db.prelevementAirs.update(paId, {
            AppareilId: ae.Id
        });

        return ae.Id;
    }

    /** DEPRECATED */
    async attachAppareilToSurface(ps: Appareil, paId: number) {
        let aeId: number;
        const ae = mapper.map(ps, Appareil, AppareilEntity);

        // const qse = await this.qualifSalleRepository.getQualifSalleEntityById(qualifSalleId);
        ae.Type = ETypeAppareil.ApplicateurContact;
        ae.Id = await db.appareils.add(ae);
        await db.prelevementSurfaces.update(paId, {
            AppareilId: ae.Id
        });

        return ae.Id;
    }

    async attachAppareilToIntervention(app: Appareil, intId: number) {
        let aeId: number;
        const ae = mapper.map(app, Appareil, AppareilEntity);

        // const qse = await this.qualifSalleRepository.getQualifSalleEntityById(qualifSalleId);
        ae.Id = await db.appareils.add(ae);

        switch (app.Type) {
            case ETypeAppareil.ApplicateurContact:
                await db.interventions.update(intId, {
                    ApplicateurContactId: ae.Id
                });
                break;
            case ETypeAppareil.Compteur:
                await db.interventions.update(intId, {
                    CompteurId: ae.Id
                });
                break;
            case ETypeAppareil.Biocollecteur:
            case ETypeAppareil.Biocollecteur2:
                await db.interventions.update(intId, {
                    BiocollecteurId: ae.Id
                });
                break;
            case ETypeAppareil.Multimetre:
                await db.interventions.update(intId, {
                    MultimetreId: ae.Id
                });
                break;
        }

        return ae.Id;
    }

    async updateAppareil(app: Appareil) {
        let ae = await this.getAppareilById(app.Id!);
        mapper.mutate(app, ae, Appareil, AppareilEntity);
        await db.appareils.update(ae.Id!, ae);
    }
}